import { configureStore } from "@reduxjs/toolkit";
import loaderSlice from "./loader/loaderSlice";
import filterSlice from "./filters/filterSlice";
import storySlice from "./stories/storySlice";
import paginationSlice from "./pagination/paginationSlice";
import settingSlice from "./settings/settingSlice";
import localizationSlice from "./localization/localizationSlice";

export const getStore = (settingState) => {
  return configureStore({
    reducer: {
      loader: loaderSlice,
      filters: filterSlice,
      story: storySlice,
      pagination: paginationSlice,
      settings: settingSlice,
      localization: localizationSlice,
    },
    preloadedState: {
      settings: settingState,
    },
    devTools: process.env.NODE_ENV === "development",
  });
};
